export const JWT_ERROR_TYPES = ['jwk_expired', 'jwk_missing', 'jwt_signature_expired']
